/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_A1dInputs */

const en_mk_sol_lembaga_a1d = /** @type {(inputs: Mk_Sol_Lembaga_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers questions about activity history and helps assemble reporting material.`)
};

const id_mk_sol_lembaga_a1d = /** @type {(inputs: Mk_Sol_Lembaga_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjawab pertanyaan tentang riwayat kegiatan dan membantu menyiapkan bahan laporan.`)
};

/**
* | output |
* | --- |
* | "Answers questions about activity history and helps assemble reporting material." |
*
* @param {Mk_Sol_Lembaga_A1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_a1d = /** @type {((inputs?: Mk_Sol_Lembaga_A1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_A1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_a1d(inputs)
	return en_mk_sol_lembaga_a1d(inputs)
});